// Authentication related types

export interface Organization {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
}

export interface UserOrganization {
  id: string;
  user_id: string;
  organization_id: string;
  organization: Organization;
  created_at: string;
}

export interface User {
  id: string;
  email: string;
  full_name: string;
  is_active: boolean;
  is_superuser: boolean;
  organizations?: UserOrganization[];
  org_logo_url?: string;
  created_at: string;
  updated_at: string;
  // 2FA fields (optional - may not be returned by all endpoints)
  totp_enabled?: boolean;
  totp_grace_period_ends_at?: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  token_type: string;
  user: User;
}

export interface RegisterRequest {
  email: string;
  password: string;
  full_name: string;
  organization_name: string;
}

export interface RegisterResponse {
  user: User;
  organization: Organization;
}

export interface RefreshTokenResponse {
  access_token: string;
  token_type: string;
}

export interface UpdateProfileRequest {
  full_name?: string;
}

export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

// 2FA Types
export interface TwoFactorSetupResponse {
  qr_code: string;
  secret: string;
  provisioning_uri: string;
}

export interface TwoFactorVerifyRequest {
  code: string;
}

export interface TwoFactorSetupCompleteResponse {
  message: string;
  backup_codes: string[];
}

export interface TwoFactorStatusResponse {
  enabled: boolean;
  backup_codes_remaining: number;
}

export interface TwoFactorRequiredResponse {
  requires_2fa: boolean;
  temp_token: string;
  message: string;
}

export interface TwoFactorVerifyLoginRequest {
  temp_token: string;
  code: string;
}

// Union type for login - can return normal login or 2FA required
export type LoginApiResponse = LoginResponse | TwoFactorRequiredResponse;

// Type guard to check if 2FA is required
export function isTwoFactorRequired(
  response: LoginApiResponse
): response is TwoFactorRequiredResponse {
  return 'requires_2fa' in response && response.requires_2fa === true;
}
